import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import { useMemo } from 'react';
import useReduxSelector from "./useReduxSelector";
var extractRawValue = function extractRawValue(actionName, apiState, args) {
  if (!apiState) return null;
  if (!actionName) return null;
  if (!apiState.requests[actionName]) return null;
  return apiState.requests[actionName][JSON.stringify(args)];
};
var getEntity = function getEntity(apiState, handle) {
  if (!handle || !handle.type) return null;
  if (!apiState || !apiState.entities) return null;
  if (!apiState.entities[handle.type]) return null;
  return apiState.entities[handle.type][handle.id];
};
var apiSelector = function apiSelector(state) {
  return state.api;
};

/**
 Retrieves from the redux state the apiCall request data.
 */
var useGetRequestInfo = function useGetRequestInfo(apiCall, args) {
  var actionName = apiCall.actionName;
  var apiState = useReduxSelector(apiSelector);
  var rawValue = useMemo(function () {
    return extractRawValue(actionName, apiState, args);
  }, [apiState, actionName, args]);
  return useMemo(function () {
    var error = !rawValue ? false : rawValue.error;
    var result = !rawValue || !rawValue.response ? null : Array.isArray(rawValue.response) ? rawValue.response.map(function (handle) {
      return getEntity(apiState, handle);
    }) : getEntity(apiState, rawValue.response);
    return {
      args: args,
      hasStarted: rawValue && !rawValue.invalid || false,
      isLoading: rawValue && rawValue.isLoading || false,
      hasFailed: !!error,
      result: result,
      headers: rawValue && rawValue.headers,
      meta: rawValue && rawValue.meta,
      error: error
    };
  }, [rawValue]);
};
export default useGetRequestInfo;